import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedErrorRed48 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M23.7497 34.1458C24.3104 34.1458 24.7805 33.9561 25.1598 33.5767C25.5392 33.1974 25.7288 32.7274 25.7288 32.1666C25.7288 31.6058 25.5392 31.1358 25.1598 30.7564C24.7805 30.3771 24.3104 30.1874 23.7497 30.1874C23.1889 30.1874 22.7189 30.3771 22.3395 30.7564C21.9602 31.1358 21.7705 31.6058 21.7705 32.1666C21.7705 32.7274 21.9602 33.1974 22.3395 33.5767C22.7189 33.9561 23.1889 34.1458 23.7497 34.1458ZM21.7705 26.2291H25.7288V14.3541H21.7705V26.2291ZM23.7497 44.0416C21.0118 44.0416 18.4389 43.5221 16.0309 42.483C13.6229 41.4439 11.5283 40.0338 9.74707 38.2525C7.96582 36.4713 6.55566 34.3767 5.5166 31.9687C4.47754 29.5607 3.95801 26.9878 3.95801 24.2499C3.95801 21.5121 4.47754 18.9392 5.5166 16.5312C6.55566 14.1232 7.96582 12.0286 9.74707 10.2473C11.5283 8.46606 13.6229 7.05591 16.0309 6.01685C18.4389 4.97778 21.0118 4.45825 23.7497 4.45825C26.4875 4.45825 29.0604 4.97778 31.4684 6.01685C33.8764 7.05591 35.971 8.46606 37.7523 10.2473C39.5335 12.0286 40.9437 14.1232 41.9827 16.5312C43.0218 18.9392 43.5413 21.5121 43.5413 24.2499C43.5413 26.9878 43.0218 29.5607 41.9827 31.9687C40.9437 34.3767 39.5335 36.4713 37.7523 38.2525C35.971 40.0338 33.8764 41.4439 31.4684 42.483C29.0604 43.5221 26.4875 44.0416 23.7497 44.0416Z",
		fill: "url(#paint0_linear_18555_4941)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_18555_4941",
		x1: 3.74973,
		y1: 44.5625,
		x2: 50.4325,
		y2: 14.2186,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#EB214D" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#EB214D"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FBBECB"
			})
		]
	}) })]
});
export default SvgExtendedErrorRed48;
